<div class="content-message-container">
    @if (type() === messageType.SUCCESS) {
        <div>
            <div class="content-message success mb-2" [ngClass]="showIcon() ? 'theme-check' : ''">
                @if (showClose()) {
                    <span class="ui-icon theme-close-small"></span>
                }
                <div class="page-matrix">
                    <div>
                        <div class="pc-text pc-component">
                            <section class="pc-richtext break-word">
                                <ng-content select="[success]"></ng-content>
                            </section>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }

    @if (type() === messageType.ERROR) {
        <div>
            <div class="content-message error mb-2" [ngClass]="showIcon() ? 'theme-error-i' : ''">
                @if (showClose()) {
                    <span class="ui-icon theme-close-small"></span>
                }
                <div class="page-matrix">
                    <div>
                        <div class="pc-text pc-component">
                            <section class="pc-richtext break-word">
                                <ng-content select="[error]"></ng-content>
                            </section>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }

    @if (type() === messageType.WARNING) {
        <div>
            <div class="content-message warning mb-2" [ngClass]="[p1Class(), showIcon() ? 'theme-warning' : '']">
                @if (showClose()) {
                    <span class="ui-icon theme-close-small"></span>
                }
                <div class="page-matrix">
                    <div>
                        <div class="pc-text pc-component">
                            <section class="pc-richtext break-word">
                                <ng-content select="[warning]"></ng-content>
                            </section>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }

    @if (type() === messageType.INFO) {
        <div>
            <div class="content-message info mb-2" [ngClass]="showIcon() ? 'theme-info-i' : ''">
                @if (showClose()) {
                    <span class="ui-icon theme-close-small" (click)="closeMessage()"></span>
                }
                <div class="page-matrix">
                    <div>
                        <div class="pc-text pc-component">
                            <section class="pc-richtext break-word">
                                <ng-content select="[info]"></ng-content>
                            </section>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
</div>
